import React from 'react'

const BookmarkFillIcon = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5469 1.5H6.31687C4.71937 1.5 3.42188 2.805 3.42188 4.395V14.9625C3.42188 16.3125 4.38938 16.8825 5.57438 16.23L9.23438 14.1975C9.62437 13.98 10.2544 13.98 10.6369 14.1975L14.2969 16.23C15.4819 16.89 16.4494 16.32 16.4494 14.9625V4.395C16.4419 2.805 15.1444 1.5 13.5469 1.5ZM12.1894 7.3125C11.4619 7.575 10.6969 7.71 9.93188 7.71C9.16688 7.71 8.40188 7.575 7.67438 7.3125C7.38188 7.2075 7.23188 6.885 7.33688 6.5925C7.44938 6.3 7.77188 6.15 8.06438 6.255C9.27188 6.69 10.5994 6.69 11.8069 6.255C12.0994 6.15 12.4219 6.3 12.5269 6.5925C12.6319 6.885 12.4819 7.2075 12.1894 7.3125Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default BookmarkFillIcon
